module.exports = __webpack_public_path__ + "static/media/02.f4bfaff5.jpg";